import { RouteSubPage } from "shared/route-types";
import { useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { AccountMenu } from "components/page/account/menu";
import { AccountProfile } from "components/page/account/profile";
import { AccountProjects } from "components/page/account/projects";
import { GetProjectsResponse } from "api/generatedApi";
import { NotificationsPage } from "components/page/account/notifications";
import { InformationPage } from "components/page/account/information";
import { FavoritesPage } from "components/page/account/personal-favorit-page";

interface Props {
  subPage: RouteSubPage;
  projects?: GetProjectsResponse;
}

export const DesktopAccountPage = (props: Props) => {
  const { subPage, projects } = props;
  let selectedSubPage = subPage;
  const navigate = useNavigate();
  let url = "";
  const menuSelected = (page: RouteSubPage) => {
    selectedSubPage = page;
    if (page === "admin") {
      url = `/${page}`;
    } else {
      url = `/account/${page}`;
    }
    navigate(url);
  };
  return (
    <Box display="flex" height="100vh" width="100vw">
      <Box
        sx={{
          width: { xs: 220, sm: 240, md: 260, lg: 280 }, // Responsive width
          flexShrink: 0, // Prevent shrinking
          bgcolor: "primary.light",
          borderRight: 1,
          borderColor: "divider",
          height: "100vh",
          zIndex: 1, // Always on top if you ever add overlays
        }}
      >
        <AccountMenu subPage={subPage} menuSelectedProps={menuSelected} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, overflow: "auto", height: "100vh" }}>
        {selectedSubPage === "profile" && <AccountProfile />}
        {selectedSubPage === "projects" && <AccountProjects />}
        {selectedSubPage === "favorites" && <FavoritesPage />}
        {selectedSubPage === "notifications" && <NotificationsPage />}
        {selectedSubPage === "information" && <InformationPage />}
      </Box>
    </Box>
  );
};
